import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  mobileGridLayout: {
    '@media (max-width: 768px)': {
      display: 'grid',
      gridAutoFlow: 'row',
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto auto',
      '& > *:nth-child(1)': {
        gridRowStart: 2,
        gridRowEnd: 3,
        gridColumnStart: 1,
        gridColumnEnd: 2,
      },
      '& > *:nth-child(2)': {
        gridRowStart: 1,
        gridRowEnd: 2,
        gridColumnStart: 1,
        gridColumnEnd: 2,
      },
    },
  },
});
